export const BOOKS = [
  {
    id: "maries_mysterious_rock",
    name: "Marie's Mysterious Rock",
    subtitle: "Humans of Science STEM Series",
    color: "#E8A020",
    colorDark: "#B57A10",
    bgGradient: "linear-gradient(135deg, #F4C355, #E8A020)",
    emoji: "🪨",
    description: "Discover the secrets of the fun-filled radioactive world",
    scientist: "Marie Curie"
  },
  {
    id: "einsteins_wonders",
    name: "Einstein's Wonders",
    subtitle: "Humans of Science STEM Series",
    color: "#7B52C8",
    colorDark: "#5A3A9A",
    bgGradient: "linear-gradient(135deg, #A07EE8, #7B52C8)",
    emoji: "⚡",
    description: "Hop on a journey of wonder and discover power of imagination",
    scientist: "Albert Einstein"
  },
  {
    id: "archimedes_explorations",
    name: "Archimedes' Explorations",
    subtitle: "Humans of Science STEM Series",
    color: "#1AAA78",
    colorDark: "#128058",
    bgGradient: "linear-gradient(135deg, #3DD4A2, #1AAA78)",
    emoji: "🌊",
    description: "A journey through the life and wonders of Archimedes",
    scientist: "Archimedes"
  },
  {
    id: "teslas_dream",
    name: "Tesla's Dream",
    subtitle: "Humans of Science STEM Series",
    color: "#2255AA",
    colorDark: "#163A7A",
    bgGradient: "linear-gradient(135deg, #5585DD, #2255AA)",
    emoji: "🔬",
    description: "A journey through sparks, science and imagination",
    scientist: "Nikola Tesla"
  },
  {
    id: "eureka_archimedes",
    name: "'Eureka!' Says Archimedes",
    subtitle: "Humans of Science STEM Series",
    color: "#8833BB",
    colorDark: "#661A99",
    bgGradient: "linear-gradient(135deg, #BB66EE, #8833BB)",
    emoji: "💡",
    description: "Discover Archimedes' knowledge helping his country",
    scientist: "Archimedes"
  },
  {
    id: "katherines_courage",
    name: "Katherine's Courage",
    subtitle: "Humans of Science STEM Series",
    color: "#2299CC",
    colorDark: "#157799",
    bgGradient: "linear-gradient(135deg, #55CCF5, #2299CC)",
    emoji: "🚀",
    description: "A journey through the life of Katherine Johnson",
    scientist: "Katherine Johnson"
  },
  {
    id: "adas_algorithm",
    name: "Ada's Algorithm",
    subtitle: "Humans of Science STEM Series",
    color: "#C8882A",
    colorDark: "#9A6410",
    bgGradient: "linear-gradient(135deg, #EDB86A, #C8882A)",
    emoji: "💻",
    description: "Ada Lovelace's life in science and her dream of making machines do the impossible",
    scientist: "Ada Lovelace"
  },
  {
    id: "vikrams_victory",
    name: "Vikram's Victory",
    subtitle: "Humans of Science STEM Series",
    color: "#BB2233",
    colorDark: "#881525",
    bgGradient: "linear-gradient(135deg, #EE5566, #BB2233)",
    emoji: "🛸",
    description: "Join Vikram Sarabhai and discover the power of exploration",
    scientist: "Vikram Sarabhai"
  },
  {
    id: "einstein_global_citizen",
    name: "Einstein: The Global Citizen",
    subtitle: "Humans of Science STEM Series",
    color: "#228844",
    colorDark: "#155E2E",
    bgGradient: "linear-gradient(135deg, #55BB77, #228844)",
    emoji: "🌍",
    description: "A journey through the life and discoveries of Albert Einstein",
    scientist: "Albert Einstein"
  },
  {
    id: "rosalind_secret_shot",
    name: "Rosalind & the Secret Shot",
    subtitle: "Humans of Science STEM Series",
    color: "#CC3377",
    colorDark: "#991155",
    bgGradient: "linear-gradient(135deg, #EE77AA, #CC3377)",
    emoji: "🧬",
    description: "Revealing the life and discoveries of Rosalind Franklin",
    scientist: "Rosalind Franklin"
  },
  {
    id: "maries_legacy",
    name: "Marie's Legacy Lives On",
    subtitle: "Humans of Science STEM Series",
    color: "#55AA22",
    colorDark: "#3A7A14",
    bgGradient: "linear-gradient(135deg, #88DD44, #55AA22)",
    emoji: "⚗️",
    description: "Discover the secrets of the fun-filled radioactive world",
    scientist: "Marie Curie"
  }
];

export const SKILLS = [
  { id: "cognitive",        label: "Cognitive",         icon: "🧠", tooltip: "Solving problems by thinking deeply", desc: "Thinking & problem solving" },
  { id: "creative",         label: "Creative",          icon: "🎨", tooltip: "Imagining and making something unique", desc: "Imagination & expression" },
  { id: "communication",    label: "Communication",     icon: "💬", tooltip: "Sharing ideas or explaining clearly", desc: "Sharing ideas clearly" },
  { id: "social_emotional", label: "Social-Emotional",  icon: "🤝", tooltip: "Working together and understanding feelings", desc: "Teamwork & emotions" },
  { id: "physical",         label: "Physical",          icon: "🏃", tooltip: "Using hands, tools or exploring with senses", desc: "Hands-on & sensory skills" },
  { id: "practical",        label: "Practical",         icon: "🔧", tooltip: "Applying learning to real-life situations", desc: "Real-life application" }
];

export const RATING_LABELS = {
  1: "Not Yet",
  2: "Sometimes",
  3: "Mostly",
  4: "Always"
};

export const RATING_COLORS = {
  1: { bg: "#EF4444", text: "#FFFFFF", label: "Not Yet" },
  2: { bg: "#F97316", text: "#FFFFFF", label: "Sometimes" },
  3: { bg: "#EAB308", text: "#1a1a1a", label: "Mostly" },
  4: { bg: "#22C55E", text: "#FFFFFF", label: "Always" }
};

export const SCORE_COLORS = {
  1: { bg: "#FEE2E2", text: "#991B1B", border: "#FCA5A5" },
  2: { bg: "#FEF3C7", text: "#92400E", border: "#FCD34D" },
  3: { bg: "#D1FAE5", text: "#065F46", border: "#6EE7B7" },
  4: { bg: "#BBF7D0", text: "#14532D", border: "#4ADE80" }
};
